export const LOGIN_EMAIL_INPUT_TEST_ID = "login-email-input";
export const LOGIN_PASSWORD_INPUT_TEST_ID = "login-password-input";
export const LOGIN_SUBMIT_BUTTON_TEST_ID = "login-submit-button";
